// extracted by mini-css-extract-plugin
export default {"header":"Label_header__-GCCv","content":"Label_content__57TED","index":"Label_index__oBYu2","label":"Label_label__JGsHC","color":"Label_color__Mp6sN","text":"Label_text__FG1-3"};